import { Grid, Skeleton } from '@chakra-ui/react';
import range from 'lodash/range';
import { useListingPageContext } from '../ListingPageContext';
import { ListingPageMetricCard } from './Card/ListingPageMetricCard';
import { METRIC_CARD_MIN_HEIGHT } from './constants';

export const ListingPageMetricsGrid = () => {
  const { metrics, isLoadingReport, includeIndigoData, isViewOnly } =
    useListingPageContext();

  return (
    <Grid
      gap={4}
      gridTemplateColumns={{ base: '1fr', xl: '1fr 1fr' }}
      gridTemplateRows={{ base: '1fr', xl: '1fr 1fr' }}
      width="100%"
    >
      {isLoadingReport
        ? range(0, 4).map((index) => (
            <Skeleton
              key={index}
              height={METRIC_CARD_MIN_HEIGHT}
              width="100%"
            />
          ))
        : metrics?.map((metric) => (
            <ListingPageMetricCard
              key={metric.title}
              includeIndigoData={includeIndigoData}
              isViewOnly={isViewOnly === true}
              metricData={metric.chart}
              showEmptyState={!includeIndigoData && !metric.chart}
              title={metric.title}
            />
          ))}
    </Grid>
  );
};
